<ng-container *transloco="let convert;">
  <div class="edit-posting-form">
    <h3 class="content-card-title">{{convert('sellModule.posting.mechanicalForm.textMechanical')}}</h3>
    <div class="content-card-subtitle">{{convert('sellModule.posting.mechanicalForm.textReviewOption')}}</div>

    <form class="body" name="mechanicalForm" [formGroup]="mechanicalForm" nonvalidate (keydown.enter)="$event.preventDefault()">
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="control-wrapper form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input excludes__input" id="showAllOptions"
                [attr.aria-label]="convert('sellModule.posting.mechanicalForm.ariaLabelShowAllOption')" data-track-name="Show All Options"
                data-track-elem="check box"
                [checked]="showAllOptions" (change)="toggleAllOptions()"/>
              <label class="custom-control-label excludes__label" for="showAllOptions">{{convert('sellModule.posting.mechanicalForm.ariaLabelShowAllOption')}}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-3">
          <div class="form-group">
            <label for="brakes">{{convert('sellModule.posting.mechanicalForm.labelBrakes')}}</label>
            <div class="select-wrapper">
              <select formControlName="brakes" id="brakes" class="custom-select wrapText"
                (change)="trackFormChanges()">
                <option disabled>{{convert('sellModule.posting.mechanicalForm.textAftermarketOption')}}</option>
                <option [ngValue]="'default'">{{convert('sellModule.posting.mechanicalForm.textSelect')}}</option>
                @for (option of vehicleBrakesDisplayOption; track option) {
                  <option [ngValue]="option">
                    {{option.platformCustomDescription}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="Abs">{{convert('sellModule.posting.mechanicalForm.labelABS')}}</label>
            <div class="select-wrapper">
              <select formControlName="abs" id="abs" class="custom-select wrapText" (change)="trackFormChanges()">
                <option disabled>{{convert('sellModule.posting.mechanicalForm.textAftermarketOption')}}</option>
                <option [ngValue]="'default'">{{convert('sellModule.posting.mechanicalForm.textSelect')}}</option>
                @for (option of vehicleAbsDisplayOption; track option) {
                  <option [ngValue]="option">
                    {{option.platformCustomDescription}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="Induction">{{convert('sellModule.posting.mechanicalForm.labelInduction')}}</label>
            <div class="select-wrapper">
              <select formControlName="induction" id="induction" class="custom-select wrapText" (change)="trackFormChanges()">
                <option disabled>{{convert('sellModule.posting.mechanicalForm.textAftermarketOption')}}</option>
                <option [ngValue]="'default'">{{convert('sellModule.posting.mechanicalForm.textSelect')}}</option>
                @for (option of vehicleInductionDisplayOption; track option) {
                  <option [ngValue]="option">
                    {{option.platformCustomDescription}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-3">
          <div class="form-group">
            <label for="Transmission">{{convert('sellModule.posting.mechanicalForm.labelTransmission')}}</label>
            <div class="select-wrapper">
              <select formControlName="transmission" id="transmission" class="custom-select wrapText" (change)="trackFormChanges()">
                <option disabled>{{convert('sellModule.posting.mechanicalForm.textAftermarketOption')}}</option>
                <option [ngValue]="'default'">{{convert('sellModule.posting.mechanicalForm.textSelect')}}</option>
                @for (option of vehicleTransmissionDisplayOption; track option) {
                  <option [ngValue]="option">
                    {{option.platformCustomDescription}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="rearAxleRatio">{{convert('sellModule.posting.mechanicalForm.labelRearAxleRatio')}}</label>
            <div class="select-wrapper">
              <select formControlName="rearAxleRatio" id="rearAxleRatio" class="custom-select wrapText" (change)="trackFormChanges()">
                <option [ngValue]="'default'">{{convert('sellModule.posting.mechanicalForm.textSelect')}}</option>
                @for (option of vehicleRearAxleRatioOption; track option) {
                  <option [ngValue]="option.optionSeqId">
                    {{option.optionDescription}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
      <app-options-and-accessories-form [otherOptions]="otherOptions" (onUpdateInstalledOptions)="installOptions($event)" (onRemoveOptionUpdateAvailableOptions)="removeOption($event)">
      </app-options-and-accessories-form>
    </form>
  </div>
</ng-container>
